const { apiRequest } = require("Services")

export const updateEmail = async (customer, newemail,isCustomer) => {
    await apiRequest({ method: 'patch', payload: { email: newemail }, url: `/${isCustomer ? 'shop':'operations' }/customers/${customer?.id}/` })
}